const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNetherlandsRound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(68.235294%,10.980392%,15.686275%)",
      fillOpacity: 1
    },
    d: "M 1.078125 10.714844 L 30.886719 10.714844 C 28.714844 4.578125 22.871094 0.179688 15.992188 0.175781 L 15.96875 0.175781 C 9.09375 0.179688 3.246094 4.578125 1.078125 10.714844 Z M 1.078125 10.714844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(12.941176%,27.45098%,54.509804%)",
      fillOpacity: 1
    },
    d: "M 30.886719 21.25 L 1.078125 21.25 C 3.25 27.390625 9.101562 31.789062 15.980469 31.789062 C 22.863281 31.789062 28.714844 27.390625 30.886719 21.25 Z M 30.886719 21.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(95.294118%,95.686275%,96.078431%)",
      fillOpacity: 1
    },
    d: "M 30.886719 21.25 C 31.46875 19.601562 31.789062 17.828125 31.789062 15.980469 C 31.789062 14.132812 31.46875 12.363281 30.886719 10.714844 L 1.078125 10.714844 C 0.496094 12.363281 0.175781 14.132812 0.175781 15.980469 C 0.175781 17.828125 0.496094 19.601562 1.078125 21.25 Z M 30.886719 21.25 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetherlandsRound);
export default __webpack_public_path__ + "static/media/netherlands-round.1f9ed4a0f29d134137c8f21aeb54fd6b.svg";
export { ForwardRef as ReactComponent };